// import React, { useState, useEffect, useRef } from "react";
// import "./pop.css";
// import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

// export default function CustomSearchDropdown({
//   label,
//   optionsData, // List of available options
//   selected,
//   setSelected,
//   placeholder = "Search...", // Placeholder for input
//   isRequired = false, // To mark the field as required
//   onSearchKeyChange, // Callback to send searchKey to parent component
//   onDropdownClose, // New callback to trigger API on dropdown close
//   headers = [], // Array for headers
// }) {
//   const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
//   const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
//   const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
//   const dropdownRef = useRef(null); // To detect outside clicks

//   // Filter options based on search term
//   useEffect(() => {
//     const filtered = searchTerm
//       ? optionsData.filter(
//           (option) =>
//             option.label &&
//             option.label.toLowerCase().includes(searchTerm.toLowerCase())
//         )
//       : optionsData;
//     setFilteredOptions(filtered);
//   }, [searchTerm, optionsData]);

//   // Handle selection of individual items in the table
//   const handleSelect = (option) => {
//     if (!selected.includes(option.id)) {
//       setSelected([...selected, option.id]);
//     } else {
//       setSelected(selected.filter((id) => id !== option.id));
//     }
//   };

//   // Close dropdown on outside click and trigger API call
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false); // Close dropdown when clicking outside
//         if (onSearchKeyChange) {
//           onSearchKeyChange(searchTerm); // Update search key
//         }
//         if (onDropdownClose) {
//           onDropdownClose(); // Trigger API call after dropdown closes
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchTerm, onSearchKeyChange, onDropdownClose]);

//   return (
//     <div className="custom-dropdown-container-FC" ref={dropdownRef}>
//       <label className="dropdown-label-FC">{label}</label>

//       <div className="dropdown-btn-FC">
//         <input
//           type="text"
//           value={searchTerm} // Show the search term in the input
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder={placeholder} // Placeholder when no selection
//           onClick={() => setIsActive(true)} // Open dropdown when typing
//           className="dropdown-input-FC"
//         />
//         <img
//           src={SearchIcon}
//           onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
//           style={{ width: "20px" }}
//           alt="Search"
//         />
//       </div>

//       {isActive && (
//         <div className="dropdown-content-FC">
//           {/* Render filtered options in a table */}
//           {filteredOptions.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   {headers.map((header, index) => (
//                     <th key={index}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredOptions.map((option) => (
//                   <tr
//                     key={option.id}
//                     className={selected.includes(option.id) ? "selected" : ""}
//                     onClick={() => handleSelect(option)}
//                     style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
//                   >
//                     <td>{option1}</td>
//                     <td>{option2}</td>
//                     <td>{option3}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="dropdown-no-options-FC">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import "./pop.css";
// import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

// export default function CustomSearchDropdown({
//   label,
//   optionsData, // List of available options
//   selected,
//   setSelected,
//   placeholder = "Search...", // Placeholder for input
//   isRequired = false, // To mark the field as required
//   onSearchKeyChange, // Callback to send searchKey to parent component
//   onDropdownClose, // New callback to trigger API on dropdown close
//   headers = [], // Array for headers
//   optionFields = {}, // Fields to display in the table rows
// }) {
//   const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
//   const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
//   const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
//   const dropdownRef = useRef(null); // To detect outside clicks

//   // Filter options based on search term
//   useEffect(() => {
//     const filtered = searchTerm
//       ? optionsData.filter((option) =>
//           option[optionFields.option1]
//             .toLowerCase()
//             .includes(searchTerm.toLowerCase())
//         )
//       : optionsData;
//     setFilteredOptions(filtered);
//   }, [searchTerm, optionsData, optionFields]);

//   // Handle selection of individual items in the table
//   const handleSelect = (option) => {
//     if (!selected.includes(option.id)) {
//       setSelected([...selected, option.id]);
//     } else {
//       setSelected(selected.filter((id) => id !== option.id));
//     }
//   };

//   // Close dropdown on outside click and trigger API call
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false); // Close dropdown when clicking outside
//         if (onSearchKeyChange) {
//           onSearchKeyChange(searchTerm); // Update search key
//         }
//         if (onDropdownClose) {
//           onDropdownClose(); // Trigger API call after dropdown closes
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchTerm, onSearchKeyChange, onDropdownClose]);

//   return (
//     <div className="custom-dropdown-container-FC" ref={dropdownRef}>
//       <label className="dropdown-label-FC">{label}</label>

//       <div className="dropdown-btn-FC">
//         <input
//           type="text"
//           value={searchTerm} // Show the search term in the input
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder={placeholder} // Placeholder when no selection
//           onClick={() => setIsActive(true)} // Open dropdown when typing
//           className="dropdown-input-FC"
//         />
//         <img
//           src={SearchIcon}
//           onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
//           style={{ width: "20px" }}
//           alt="Search"
//         />
//       </div>

//       {isActive && (
//         <div className="dropdown-content-FC">
//           {/* Render filtered options in a table */}
//           {filteredOptions.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   {headers.map((header, index) => (
//                     <th key={index}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredOptions.map((option) => (
//                   <tr
//                     key={option.id}
//                     className={selected.includes(option.id) ? "selected" : ""}
//                     onClick={() => handleSelect(option)}
//                     style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
//                   >
//                     <td>{option[optionFields.option1]}</td>
//                     <td>{option[optionFields.option2]}</td>
//                     <td>{option[optionFields.option3]}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="dropdown-no-options-FC">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import "./pop.css";
// import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

// export default function CustomSearchDropdown({
//   label,
//   optionsData, // List of available options
//   selected,
//   setSelected,
//   placeholder = "Search...", // Placeholder for input
//   isRequired = false, // To mark the field as required
//   onSearchKeyChange, // Callback to send searchKey to parent component
//   onDropdownClose, // Callback to trigger API on dropdown close
//   headers = [], // Array for headers
//   optionFields = {}, // Fields to display in the table rows
//   customwidth,
// }) {
//   const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
//   const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
//   const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
//   const [isAllSelected, setIsAllSelected] = useState(false); // State for Select All
//   const dropdownRef = useRef(null); // To detect outside clicks

//   // Filter options based on search term
//   useEffect(() => {
//     const filtered = searchTerm
//       ? optionsData.filter((option) =>
//           option[optionFields.option1]
//             .toLowerCase()
//             .includes(searchTerm.toLowerCase())
//         )
//       : optionsData;
//     setFilteredOptions(filtered);
//   }, [searchTerm, optionsData, optionFields]);

//   // Handle selection of individual items in the table
//   const handleSelect = (option, event) => {
//     event.stopPropagation(); // Prevent event bubbling
//     event.preventDefault(); // Prevent default event

//     if (!selected.includes(option.id)) {
//       setSelected([...selected, option.id]);
//     } else {
//       setSelected(selected.filter((id) => id !== option.id));
//     }
//   };

//   // Handle 'Select All' functionality
//   const handleSelectAll = (event) => {
//     event.stopPropagation(); // Prevent event bubbling
//     if (!isAllSelected) {
//       const allIds = filteredOptions.map((option) => option.id);
//       setSelected(allIds); // Select all filtered options
//     } else {
//       setSelected([]); // Deselect all options
//     }
//     setIsAllSelected(!isAllSelected); // Toggle Select All state
//   };

//   // Close dropdown on outside click and trigger API call
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false); // Close dropdown when clicking outside
//         if (onSearchKeyChange) {
//           onSearchKeyChange(searchTerm); // Update search key
//         }
//         if (onDropdownClose) {
//           onDropdownClose(); // Trigger API call after dropdown closes
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchTerm, onSearchKeyChange, onDropdownClose]);

//   return (
//     <div className="custom-dropdown-container-FC" >
//       <label className="dropdown-label-FC">{label}</label>

//       <div className="dropdown-btn-FC">
//         <input
//           type="text"
//           value={searchTerm} // Show the search term in the input
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder={placeholder} // Placeholder when no selection
//           onClick={() => setIsActive(true)} // Open dropdown when typing
//           className="dropdown-input-FC"
//         />
//         <img
//           src={SearchIcon}
//           onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
//           style={{ width: "20px" }}
//           alt="Search"
//         />
//       </div>

//       {isActive && (
//         <div className="dropdown-content-FC" style={{ width: customwidth }} ref={dropdownRef}>
//           {/* Select All Checkbox */}
//           <div className="select-all-container-FC" style={{ padding: "4px" }}>
//             <input
//               type="checkbox"
//               checked={
//                 isAllSelected ||
//                 (selected.length === filteredOptions.length &&
//                   selected.length > 0)
//               }
//               onChange={handleSelectAll} // Select or Deselect all
//             />
//             <label style={{ marginLeft: "8px" }}>Select All</label>
//           </div>

//           {/* Render filtered options in a table */}
//           {filteredOptions.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   <th></th>
//                   {headers.map((header, index) => (
//                     <th key={index}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredOptions.map((option) => (
//                   <tr
//                     key={option.id}
//                     className={selected.includes(option.id) ? "selected" : ""}
//                     style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
//                     onClick={(event) => handleSelect(option, event)} // Handle row selection
//                   >
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selected.includes(option.id)}
//                         onChange={(event) => handleSelect(option, event)} // Prevent event bubbling
//                         onClick={(e) => e.stopPropagation()} // Prevent event bubbling for checkbox
//                       />
//                     </td>
//                     <td>{option[optionFields.option1]}</td>
//                     <td>{option[optionFields.option2]}</td>
//                     <td>{option[optionFields.option3]}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="dropdown-no-options-FC">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// working code finalyy

// import React, { useState, useEffect, useRef } from "react";
// import "./pop.css";
// import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

// export default function CustomSearchDropdown({
//   label,
//   optionsData, // List of available options
//   selected,
//   setSelected,
//   placeholder = "Search...", // Placeholder for input
//   isRequired = false, // To mark the field as required
//   onSearchKeyChange, // Callback to send searchKey to parent component
//   onDropdownClose, // Callback to trigger API on dropdown close
//   headers = [], // Array for headers
//   optionFields = {}, // Fields to display in the table rows
//   customwidth,
// }) {
//   const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
//   const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
//   const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
//   const [isAllSelected, setIsAllSelected] = useState(false); // State for Select All
//   const dropdownRef = useRef(null); // To detect outside clicks

//   // Filter options based on search term
//   useEffect(() => {
//     const filtered = searchTerm
//       ? optionsData.filter((option) =>
//           option[optionFields.option1]
//             .toLowerCase()
//             .includes(searchTerm.toLowerCase())
//         )
//       : optionsData;
//     setFilteredOptions(filtered);
//   }, [searchTerm, optionsData, optionFields]);

//   // Handle selection of individual items in the table
//   const handleSelect = (option, event) => {
//     event.stopPropagation(); // Prevent event bubbling
//     event.preventDefault(); // Prevent default event

//     if (!selected.includes(option.id)) {
//       setSelected([...selected, option.id]);
//     } else {
//       setSelected(selected.filter((id) => id !== option.id));
//     }
//   };

//   // Handle 'Select All' functionality
//   const handleSelectAll = (event) => {
//     event.stopPropagation(); // Prevent event bubbling
//     if (!isAllSelected) {
//       const allIds = filteredOptions.map((option) => option.id);
//       setSelected(allIds); // Select all filtered options
//     } else {
//       setSelected([]); // Deselect all options
//     }
//     setIsAllSelected(!isAllSelected); // Toggle Select All state
//   };

//   // Close dropdown on outside click and trigger API call
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false); // Close dropdown when clicking outside
//         if (onSearchKeyChange) {
//           onSearchKeyChange(searchTerm); // Update search key
//         }
//         if (onDropdownClose) {
//           onDropdownClose(); // Trigger API call after dropdown closes
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchTerm, onSearchKeyChange, onDropdownClose]);

//   // Function to display selected options in "option1, option2, option3" format
//   const getSelectedOptionsDisplay = () => {
//     const selectedOptions = optionsData.filter((option) =>
//       selected.includes(option.id)
//     );
//     return selectedOptions
//       .map((option) => option[optionFields.option1]) // Show option1 field as comma-separated string
//       .join(", ");
//   };

//   return (
//     <div className="custom-dropdown-container-FC">
//       <label className="dropdown-label-FC">{label}</label>

//       <div className="dropdown-btn-FC">
//         <input
//           type="text"
//           value={
//             selected.length > 0 ? getSelectedOptionsDisplay() : searchTerm
//           } // Display selected options in the input
//           onChange={(e) => setSearchTerm(e.target.value)} // Update search term based on user input
//           placeholder={placeholder} // Placeholder when no selection
//           onClick={() => setIsActive(true)} // Open dropdown when typing
//           className="dropdown-input-FC"
//         />
//         <img
//           src={SearchIcon}
//           onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
//           style={{ width: "20px" }}
//           alt="Search"
//         />
//       </div>

//       {isActive && (
//         <div className="dropdown-content-FC" style={{ width: customwidth }}  ref={dropdownRef}>
//           {/* Select All Checkbox */}
//           <div className="select-all-container-FC" style={{ padding: "4px" }}>
//             <input
//               type="checkbox"
//               checked={
//                 isAllSelected ||
//                 (selected.length === filteredOptions.length &&
//                   selected.length > 0)
//               }
//               onChange={handleSelectAll} // Select or Deselect all
//             />
//             <label style={{ marginLeft: "8px" }}>Select All</label>
//           </div>

//           {/* Render filtered options in a table */}
//           {filteredOptions.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   <th></th>
//                   {headers.map((header, index) => (
//                     <th key={index}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredOptions.map((option) => (
//                   <tr
//                     key={option.id}
//                     className={selected.includes(option.id) ? "selected" : ""}
//                     style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
//                     onClick={(event) => handleSelect(option, event)} // Handle row selection
//                   >
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selected.includes(option.id)}
//                         onChange={(event) => handleSelect(option, event)} // Prevent event bubbling
//                         onClick={(e) => e.stopPropagation()} // Prevent event bubbling for checkbox
//                       />
//                     </td>
//                     <td>{option[optionFields.option1]}</td>
//                     <td>{option[optionFields.option2]}</td>
//                     <td>{option[optionFields.option3]}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="dropdown-no-options-FC">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import "./pop.css";
import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

export default function CustomSearchDropdown({
  label,
  optionsData, // List of available options
  selected,
  setSelected,
  placeholder = "Search...", // Placeholder for input
  isRequired = false, // To mark the field as required
  onSearchKeyChange, // Callback to send searchKey to parent component
  onDropdownClose, // Callback to trigger API on dropdown close
  headers = [], // Array for headers
  optionFields = {}, // Fields to display in the table rows
  customwidth,
  dropdownWidth,
}) {
  const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
  const [filteredOptions, setFilteredOptions] = useState(optionsData); // Filtered options based on search
  const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
  const [isAllSelected, setIsAllSelected] = useState(false); // State for Select All
  const dropdownRef = useRef(null); // To detect outside clicks

  // Filter options based on search term
  useEffect(() => {
    const filtered = searchTerm
      ? optionsData.filter((option) =>
          option[optionFields.option1]
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      : optionsData;
    setFilteredOptions(filtered);
  }, [searchTerm, optionsData, optionFields]);

  // Handle selection of individual items via checkbox only
  const handleSelect = (option) => {
    if (!selected.includes(option.id)) {
      setSelected([...selected, option.id]);
    } else {
      setSelected(selected.filter((id) => id !== option.id));
    }
  };

  // Handle 'Select All' functionality
  const handleSelectAll = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    if (!isAllSelected) {
      const allIds = filteredOptions.map((option) => option.id);
      setSelected(allIds); // Select all filtered options
    } else {
      setSelected([]); // Deselect all options
    }
    setIsAllSelected(!isAllSelected); // Toggle Select All state
  };

  // Close dropdown on outside click and trigger API call
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false); // Close dropdown when clicking outside
        if (onSearchKeyChange) {
          onSearchKeyChange(searchTerm); // Update search key
        }
        if (onDropdownClose) {
          onDropdownClose(); // Trigger API call after dropdown closes
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchTerm, onSearchKeyChange, onDropdownClose]);

  // Function to display selected options in "option1, option2, option3" format
  const getSelectedOptionsDisplay = () => {
    const selectedOptions = optionsData.filter((option) =>
      selected.includes(option.id)
    );
    return selectedOptions
      .map((option) => option[optionFields.option1]) // Show option1 field as comma-separated string
      .join(", ");
  };

  return (
    <div className="custom-dropdown-container-FC">
      <label className="dropdown-label-FC">{label}</label>

      <div className="dropdown-btn-FC" style={{ width: dropdownWidth }}>
        <input
          type="text"
          value={selected.length > 0 ? getSelectedOptionsDisplay() : searchTerm} // Display selected options in the input
          onChange={(e) => setSearchTerm(e.target.value)} // Update search term based on user input
          placeholder={placeholder} // Placeholder when no selection
          onClick={() => setIsActive(true)} // Open dropdown when typing
          className="dropdown-input-FC"
        />
        <img
          src={SearchIcon}
          onClick={() => setIsActive(!isActive)} // Toggle dropdown visibility
          style={{ width: "20px" }}
          alt="Search"
        />
      </div>

      {isActive && (
        <div
          className="dropdown-content-FC"
          style={{ width: customwidth }}
          ref={dropdownRef}
        >
          {/* Select All Checkbox */}
          <div className="select-all-container-FC" style={{ padding: "4px" }}>
            <input
              type="checkbox"
              checked={
                isAllSelected ||
                (selected.length === filteredOptions.length &&
                  selected.length > 0)
              }
              onChange={handleSelectAll} // Select or Deselect all
            />
            <label style={{ marginLeft: "8px" }}>Select All</label>
          </div>

          {/* Render filtered options in a table */}
          {filteredOptions.length > 0 ? (
            <table id="customers">
              <thead>
                <tr>
                  <th></th>
                  {headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredOptions.map((option) => (
                  <tr
                    key={option.id}
                    className={selected.includes(option.id) ? "selected" : ""}
                    style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(option.id)}
                        onChange={() => handleSelect(option)} // Only change via checkbox
                      />
                    </td>
                    <td>{option[optionFields.option1]}</td>
                    <td>{option[optionFields.option2]}</td>
                    <td>{option[optionFields.option3]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="dropdown-no-options-FC">No options found</div>
          )}
        </div>
      )}
    </div>
  );
}

// import React, { useState, useEffect, useRef } from "react";
// import "./pop.css";
// import SearchIcon from "../../Assets/Images/CommanImages/Greysearchicon.png";

// export default function CustomSearchDropdown({
//   label,
//   optionsData, // List of available options
//   selected,
//   setSelected,
//   placeholder = "Search...", // Placeholder for input
//   isRequired = false, // To mark the field as required
//   onSearchKeyChange, // Callback to send searchKey to parent component
//   onDropdownClose, // Callback to trigger API on dropdown close
//   headers = [], // Array for headers
//   optionFields = {}, // Fields to display in the table rows
//   customwidth,
// }) {
//   const [searchTerm, setSearchTerm] = useState(""); // Search term input by user
//   const [filteredOptions, setFilteredOptions] = useState([]); // Filtered options based on search
//   const [isActive, setIsActive] = useState(false); // To control the dropdown visibility
//   const [isAllSelected, setIsAllSelected] = useState(false); // State for Select All
//   const dropdownRef = useRef(null); // To detect outside clicks

//   // Handle search term changes but only trigger filtering when "Enter" is pressed or search icon is clicked
//   const handleSearch = () => {
//     if (searchTerm.trim().length > 0) {
//       const filtered = optionsData.filter((option) =>
//         option[optionFields.option1]
//           .toLowerCase()
//           .includes(searchTerm.toLowerCase()) // Filter by option1
//       );
//       setFilteredOptions(filtered);
//       setIsActive(true); // Show the dropdown only when search is performed
//     } else {
//       setFilteredOptions([]);
//       setIsActive(false); // Hide the dropdown if search term is empty
//     }
//     if (onSearchKeyChange) {
//       onSearchKeyChange(searchTerm); // Pass the search term to the parent
//     }
//   };

//   // Handle key press for "Enter" to trigger search
//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleSearch(); // Trigger search on "Enter" press
//     }
//   };

//   // Handle selection of individual items via checkbox
//   const handleSelect = (option) => {
//     if (!selected.includes(option.id)) {
//       setSelected([...selected, option.id]);
//     } else {
//       setSelected(selected.filter((id) => id !== option.id));
//     }
//   };

//   // Handle 'Select All' functionality
//   const handleSelectAll = (event) => {
//     event.stopPropagation(); // Prevent event bubbling
//     if (!isAllSelected) {
//       const allIds = filteredOptions.map((option) => option.id);
//       setSelected(allIds); // Select all filtered options
//     } else {
//       setSelected([]); // Deselect all options
//     }
//     setIsAllSelected(!isAllSelected); // Toggle Select All state
//   };

//   // Close dropdown on outside click and trigger API call
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false); // Close dropdown when clicking outside
//         if (onDropdownClose) {
//           onDropdownClose(); // Trigger API call after dropdown closes
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [onDropdownClose]);

//   // Function to display selected options
//   const getSelectedOptionsDisplay = () => {
//     const selectedOptions = optionsData.filter((option) =>
//       selected.includes(option.id)
//     );
//     return selectedOptions
//       .map((option) => option[optionFields.option1]) // Display the selected field
//       .join(", ");
//   };

//   return (
//     <div className="custom-dropdown-container-FC">
//       <label className="dropdown-label-FC">{label}</label>

//       <div className="dropdown-btn-FC">
//         <input
//           type="text"
//           value={
//             selected.length > 0 ? getSelectedOptionsDisplay() : searchTerm
//           } // Display selected options in the input
//           onChange={(e) => setSearchTerm(e.target.value)} // Update search term based on user input
//           placeholder={placeholder} // Placeholder when no selection
//           onKeyPress={handleKeyPress} // Trigger search on Enter key press
//           className="dropdown-input-FC"
//         />
//         <img
//           src={SearchIcon}
//           onClick={handleSearch} // Trigger search on icon click
//           style={{ width: "20px", cursor: "pointer" }}
//           alt="Search"
//         />
//       </div>

//       {isActive && (
//         <div className="dropdown-content-FC" style={{ width: customwidth }} ref={dropdownRef}>
//           {/* Select All Checkbox */}
//           <div className="select-all-container-FC" style={{ padding: "4px" }}>
//             <input
//               type="checkbox"
//               checked={
//                 isAllSelected ||
//                 (selected.length === filteredOptions.length &&
//                   selected.length > 0)
//               }
//               onChange={handleSelectAll} // Select or Deselect all
//             />
//             <label style={{ marginLeft: "8px" }}>Select All</label>
//           </div>

//           {/* Render filtered options in a table */}
//           {filteredOptions.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   <th></th>
//                   {headers.map((header, index) => (
//                     <th key={index}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredOptions.map((option) => (
//                   <tr
//                     key={option.id}
//                     className={selected.includes(option.id) ? "selected" : ""}
//                     style={{ cursor: "pointer" }} // Change cursor to indicate selectable rows
//                   >
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selected.includes(option.id)}
//                         onChange={() => handleSelect(option)} // Only change via checkbox
//                       />
//                     </td>
//                     <td>{option[optionFields.option1]}</td>
//                     <td>{option[optionFields.option2]}</td>
//                     <td>{option[optionFields.option3]}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="dropdown-no-options-FC">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
